<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel">
                    </toolBar>
                    <tableGrid ref="tableGrid"
                               :sumObject="sumObject"
                               :showSummary="showSummary"
                               adaptiveHeight="123"
                               :headList="headList"
                               :dataList="dataList"
                               :pageInfo="pageInfo"
                               @tableOpt="tableOpt"
                               @toPage="toPage"
                               :loading="loading">
                    </tableGrid>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/finance/billing/toolBar'
    import tableGrid from '@/components/tools/table'

    export default {
        name: "liabilities",
        props: ['menuData'],
        components: {tableGrid, toolBar},
        data() {
            return {
                showSummary:true,
                sumObject: {},
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {
                        column_name: "_px", column_comment: "序号", column_width: "70"
                    },
                    {
                        column_name: "billNo", column_comment: "凭证编号", column_width: "150"
                    },
                    {
                        column_name: "billDate", column_comment: "凭证日期", column_width: "120"
                    },
                    {
                        column_name: "relaBillType", column_comment: "关联账单类型", column_width: "150"
                    },
                    {
                        column_name: "relaBillNo", column_comment: "关联账单编号", column_width: "150"
                    },
                    {
                        column_name: "relaBillDate", column_comment: "关联账单日期", column_width: "120"
                    },
                    {
                        column_name: "summary", column_comment: "摘要", column_width: "250"
                    },
                    {
                        column_name: "accTitleName", column_comment: "会计科目", column_width: "200"
                    },
                    {
                        column_name: "debitTotal", column_comment: "借方金额", column_width: "150"
                    },
                    {
                        column_name: "creditTotal", column_comment: "贷方金额", column_width: "150"
                    },
                    {
                        column_name: "remark", column_comment: "备注", column_width: "210"
                    }
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        mounted() {
            //this.getListData();
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/financestatistics/listBilling",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel(data) {
                this.searchData.formData = data;

                let param = {
                    url: "/financestatistics/excelBilling",
                    param: {
                        ...this.searchData.formData
                    }
                }
                this.$pub.openPostWindow(param);
            },
            tableOpt() {
            },
        }
    }
</script>

<style scoped lang="scss">

    ::v-deep .el-tabs__header{
        margin:0px;
    }
    ::v-deep .el-tabs--border-card>.el-tabs__content{
        padding: 10px;
    }

   .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
